/* Load the location map as visitors approach it, after the repair form. */
(() => {
  if (customElements.get('sm-lazy-map')) return;

  customElements.define('sm-lazy-map', class extends HTMLElement {
    connectedCallback() {
      const frame = this.querySelector('iframe[data-src]');
      if (!frame || frame.hasAttribute('src')) return;

      const load = () => {
        const source = frame.getAttribute('data-src');
        if (!source || frame.hasAttribute('src')) return;
        this.observer?.disconnect();
        this.observer = null;
        frame.src = source;
        frame.removeAttribute('data-src');
      };

      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }

      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) load();
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  });
})();
